import { z } from "zod";

export const TRawPropertyActionValidator = z.object({
  actions: z
    .record(
      z.string(),
      z.object({
        allowedGroups: z.array(z.string()).optional(),
      })
    )
    .optional(),
});
export type IRawPropertyActionValidator = z.infer<typeof TRawPropertyActionValidator>;

export const TApiActionValidatorResponse = z.object({
  data: z.record(TRawPropertyActionValidator),
});
export type IApiActionValidatorResponse = z.infer<typeof TApiActionValidatorResponse>;
